import { render, staticRenderFns } from "./noImg.vue?vue&type=template&id=09c68684&"
import script from "./noImg.vue?vue&type=script&lang=js&"
export * from "./noImg.vue?vue&type=script&lang=js&"
import style0 from "./noImg.vue?vue&type=style&index=0&id=09c68684&prod&lang=less&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports